<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { Button } from 'carbon-components-svelte';
  import TrashCan16 from 'carbon-icons-svelte/lib/TrashCan16';

  import Edit16 from 'carbon-icons-svelte/lib/Edit16';
  import Save16 from 'carbon-icons-svelte/lib/Save16';

  import type { DraftEntitlementPatch, EntitlementRow, RowValidationErrors } from '../entitlements-table-types';

  export let row: EntitlementRow,
    rowValidationErrors: RowValidationErrors = {};

  const dispatch = createEventDispatcher<{
    'delete-row': { rowId: string };
    'change-row': { rowId: string; patch: DraftEntitlementPatch };
  }>();

  const hasValidationErrors = (currentRowValidationErrors: RowValidationErrors = rowValidationErrors): boolean =>
    Object.values(currentRowValidationErrors).some(Boolean);

  // we pass rowValidationErrors on purpose to trigger a re-evaluation of editMode when rowValidationErrors changes
  $: editMode = Boolean(row.isEdited) || hasValidationErrors(rowValidationErrors);
</script>

<div class="actions-cell">
  <Button
    hideTooltip
    size="small"
    kind="danger-tertiary"
    tooltipPosition="left"
    tooltipAlignment="end"
    iconDescription="Delete entitlement"
    icon={TrashCan16}
    on:click={() => dispatch('delete-row', { rowId: row.id })}
  />
  <Button
    hideTooltip
    size="small"
    kind="tertiary"
    tooltipPosition="right"
    tooltipAlignment="end"
    iconDescription={editMode ? 'Save feed' : 'Edit Feed'}
    icon={editMode ? Save16 : Edit16}
    on:click={() => {
      if (row.isEdited && hasValidationErrors()) {
        return;
      }

      dispatch('change-row', { rowId: row.id, patch: { isEdited: !row.isEdited } });
    }}
  />
</div>

<style>
  .actions-cell {
    display: flex;
  }

  .actions-cell :global(.bx--btn--icon-only:first-child) {
    border-right: unset !important;
    border-style: dashed;
  }

  .actions-cell :global(.bx--btn--icon-only) {
    padding: 0 7px !important;
  }
</style>
